<template>
  <div class="view-content view6">
    <div class="left">
      <div class="title">{{ $t('核心技术') }}</div>
      <div class="text text-padding">Neco Chain —— {{ $t('基于 Novai Chain 的二层网络') }}。</div>
      <div class="label">{{ $t('Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，') }}</div>
      <div class="label">{{ $t('专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。') }}</div>
      <div class="label">{{ $t('Neco Chain 将电商的每笔消费行为与激励记录上链，') }}</div>
      <div class="label">{{ $t('让商业行为具备长期可验证性与可追溯性。') }}</div>
    </div>
    <div class="div-no1 div-show">
        <div class="view6-footer-list">
            <div v-for="(item, index) in list" :key="index" class="view6-footer-li" :style="{transform: `translateY(${item.position})`}">
                {{ item.title }}
            </div>
        </div>
    </div>
    <div class="right">
      <img class="img" src="./img/1030/view6-1.png">
    </div>
    <div class="view6-footer div-no">
        <img ref="bgImg" class="bg-img" src="./img/1030/view6-2.png">
        <div class="view6-footer-list">
            <div v-for="(item, index) in list" :key="index" class="view6-footer-li" :style="{transform: `translateY(${item.position})`}">
                {{ item.title }}
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view6',
  data () {
    return {
        list: [
            {
                title: this.$t('高速并行账本结构'),
                position: '-5vw',
                heightNum: '100',
            },
            {
                title: this.$t('智能结算与动态费用调节'),
                position: '24px',
                heightNum: '0',
            },
            {
                title: this.$t('消费凭证 NFT 化与积分资产化'),
                position: '-5vw',
                heightNum: '140',
            },
        ]
    }
  },
  mounted () {
    // this.init()
  },
  methods: {
    // init () {
    //     this.$nextTick(() => {
    //         setTimeout(() => {
    //             const bgImg = this.$refs.bgImg
    //             this.list = this.list.map(item => {
    //                 console.log(item)
    //                 if (item.heightNum !== '0') {
    //                     item.position = `-${bgImg.clientHeight - item.heightNum}px`
    //                 }
    //                 return item
    //             })
    //         }, 300)
    //     })
    // }
  }
}
</script>

<style scoped>
@import "./css/index.css";

.view6 .label {
    padding-top: 0;
}

.view6 .label {
    padding-right: 200px;
    color: #fff;
}

.view6-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
}

.view6-footer .bg-img {
    width: 100%;
}

.view6-footer-list {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 10% 0 12%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}

.view6-footer-li {
    padding: 24px;
    gap: 10px;
    border-left: 4px solid #07C160;
    background: rgba(255, 255, 255, 0.10);
}

.div-no1 {
    display: none;
}

@media screen and (max-width: 768px) {
    .view6 {
        align-items: flex-start;
        justify-content: flex-start;
    }
    .right {
        width: 208px;
        height: 229px;
        flex-shrink: 0;
        justify-content: flex-start;
        margin-top: 0;
    }
    .div-no {
        display: none;
    }
    .div-show {
        display: block;
    }
    .view6-footer-list {
        position: relative;
        padding: 43px 0px 0px 0px;
        display: block;
    }
    .view6-footer-li {
        transform: translateY(0px) !important;
        font-size: 16px;
        margin-bottom: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view6.vue